import {Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {IdName} from '../../models/id-name.model';
import {NgModel} from '@angular/forms';

@Component({
  selector: 'si-selector-dialog',
  templateUrl: './selector-dialog.component.html',
  styleUrls: ['./selector-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SelectorDialogComponent {
  // Type of the model
  @Input() type: string;
  @Input() text: string;
  @Input() placeholder: string;
  @Input() disabled: boolean;
  @Input() rule: string;
  @Input() tooltipText: string;
  @Input() tooltipPosition: string;
  @Input() tooltipIcon: string;
  @Input() tooltipStyleClass: string;
  @Input() tooltipEscape = true;
  @Input() forceShowTooltipIcon: boolean;
  @Input() showClear = true;
  @Input() hideLabel = false;
  @Input() displayDialog = false;
  @Output() displayDialogChange = new EventEmitter<boolean>();
  @Output() modelChange = new EventEmitter<IdName | string>();
  @Output() tooltipIconClick = new EventEmitter<any>();
  @ViewChild('formModel') formModel: NgModel;
  private _model: any; // IdName | string

  constructor() {
  }

  get model() {
    return this._model;
  }

  @Input()
  set model(val) {
    this._model = val;
    if (val) {
      this.formModel.control.markAsDirty();
    }
  }

  onClickClearIcon(event): void {
    event.stopPropagation();
    this._model = null;
    this.modelChange.emit(this.model);
  }

  onClickShowDialog(): void {
    this.displayDialog = true;
    this.displayDialogChange.emit(this.displayDialog);
  }

  onClickTooltipIcon(event: any): void {
    this.tooltipIconClick.emit(event);
  }
}
